/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'PlanGroupService';

export default function PlanGroupService(SnapConst, SnapService) {
  "ngInject";

  function Group(s, name, shape) {
    //Normalize input
    shape = _.clone(shape) || {};
    if (!shape.type) {
      shape.type = SnapConst.Shapes.Rect;
    }
    //Assigne values
    this.s = s;
    this.name = name;
    this.shape = shape;
    this.type = 'group';
    this.elements = {};
    this.g = s.g();
    this.g.addClass(this.type + ' ' + this.shape.type + ' ' + this.name);
    this.g.attr({
      'data-name': this.name
    });
  }

  Group.prototype = {

    buildRootElement: function () {
      if (this.getElement('root')) {
        console.warn('root element already defined for', this.name);
        return;
      }
      var e = SnapService.buildElement(this.s, this.shape).addClass('root');
      this.addElement(e, 'root');
    },

    addElement: function (Selement, key) {
      if (Selement) {
        if (!key) {
          console.error(this.type + '.' + this.name + ' addElement : missing key for element', Selement);
          return;
        }

        /**
         * JIRA: NBI-550
         * If trying to add an element that already exists, we must first remove the existing one.
         * If you don't Snap will add them both
         */
        // if (this.elements[key]) {
        //   this.removeElement(key);
        //   console.warn(this.type + '.' + this.name + ' addElement : existing element for key', key, 'Auto-removing duplicate element');
        // } else {
        //   console.log('added normally', key);
        // }
        this.g.add(SnapService.getElement(Selement));
        this.elements[key] = Selement;
      }
    },

    getElement: function (key) {
      if (!key) {
        console.error(this.type + '.' + this.name + ' getElement : missing param key', key);
        return null;
      }
      if (!this.elements[key]) {
        return null;
      }
      return SnapService.getElement(this.elements[key]);
    },

    removeElement: function (key) {
      if (!key) {
        console.error(this.type + '.' + this.name + ' removeElement : missing param key', key);
      } else {
        var Selement = this.getElement(key);
        if (Selement) {
          Selement.remove();
          delete this.elements[key];
        }
      }
    },

    clear: function (removeRootElement) {
      _.each(this.elements, function (el, key) {
        if (removeRootElement || key !== 'root') {
          this.removeElement(key);
        }
      }, this);
    },

    getSGroup: function () {
      return this.g;
    }
  };

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  return Group;
}
